import { render, staticRenderFns } from "./LifemapApp.vue?vue&type=template&id=55efecf2&"
import script from "./LifemapApp.vue?vue&type=script&lang=js&"
export * from "./LifemapApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports